module.exports = __webpack_public_path__ + "static/FS-Barrier-2-1-c6f5e07cd7f76c37e1530b1a8fecc498.png";